
export enum CommonTranslKey {
    ADD = "common:add",
    ADMINISTRATION = "common:administration",
    CANCEL = "common:cancel",
    CLOSE = "common:close",
    CONFIRM = "common:confirm",
    CONTAINS_VALIDATION_ERRORS = "common:containsValidationErrors",
    DATA_DELETED = "common:dataDeleted",
    DATA_INVALIDATED = "common:dataInvalidated",
    DATA_SAVED = "common:dataSaved",
    DELETE = "common:delete",
    DETAILS = "common:details",
    EDIT = "common:edit",
    INVALIDATE = "common:invalidate",
    NO = "common:no",
    SAVE = "common:save",
    SEARCH = "common:search",
    SHOW_DETAILS = "common:showDetails",
    UNEXPECTED_ERROR = "common:unexpectedError",
    YES = "common:yes",
}
